const Module3Config = {
  day1: {
    learn: {
      video: 'Module3Videos/learn_day_1.mp4',
      song: 'appfiles/expressions/school_photo_montage_music_1.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_1.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_day_1.mp4',
    },
    rewardOption1: 'CactusTall',
    rewardOption2: 'CactusTall2',
  },
  day2: {
    learn: {
      video: 'Module3Videos/learn_day_2.mp4',
      song: 'appfiles/expressions/school_photo_montage_music_2.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_2.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_day_2.mp4',
    },
    rewardOption1: 'Tent',
    rewardOption2: 'TentOld',
  },
  day3: {
    learn: {
      video: 'Module3Videos/learn_day_3.mp4',
      song: 'appfiles/expressions/school_photo_montage_music_3.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_3.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_day_3.mp4',
    },
    rewardOption1: 'Hawk',
    rewardOption2: 'Owl',
  },
  day4: {
    introVideo: 'Module3Videos/welcome_day_4.mp4',
    rewardOption1: 'BootsHiking',
    rewardOption2: 'BootsCowboy',
    photoTime: {
      // video1: '0f3ed57ed3560b50aec6407c510c/480.m3u8',
      video1: 'Module3Videos/phototime.mp4',
      video2: 'Module3Videos/photo_time_2.mp4',
    },
    singingTime: {
      intro: 'Module3Videos/singing_time.mp4',
      demoMusic: '',
      singAlongMusic: 'appfiles/expressions/school_expressions_singalong.m4a',
      instrumentalMusic:
        'appfiles/expressions/school_expressions_instrumental.m4a',
      singingAlongVideo:
        'appfiles/expressions/singingtime_expressions_demo.mp4',
      instrumentalVideo:
        'appfiles/expressions/singingtime_expressions_karaoke.mp4',
    },
  },
  day5: {
    introVideo: 'Module3Videos/welcome_day_5.mp4',
    rewardOption1: 'Lantern',
    rewardOption2: 'Fire',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_5.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_intro_day_5.mp4',
      afterVideo: 'Module3Videos/celebrate_close_day_5.mp4',
      animal: true,
      text: 'Record yourself in an excited voice and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_5.mp4',
    },
  },
  day6: {
    rewardOption1: 'CactusPrickly',
    rewardOption2: 'CactusBarell',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_6.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_intro_day_6.mp4',
      afterVideo: 'Module3Videos/celebrate_close_day_6.mp4',
      animal: true,
      text: 'Record yourself in a funny voice and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_6.mp4',
    },
  },
  day7: {
    rewardOption1: 'Canteen',
    rewardOption2: 'Backpack',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_7.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_intro_day_7.mp4',
      afterVideo: 'Module3Videos/celebrate_close_day_7.mp4',
      animal: true,
      text: 'Record yourself singing, \n "I am a very important person!"',
      name: 'expressions_celebration_surprise_7.mp4',
    },
  },
  day8: {
    rewardOption1: 'MoonCresent',
    rewardOption2: 'MoonFull',
    learn: {
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      video: 'influencers/{influencer-id}/answer_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_8.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_intro_day_8.mp4',
      afterVideo: 'Module3Videos/celebrate_close_day_8.mp4',
      animal: true,
      text: 'Record yourself making a silly face and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_8.mp4',
    },
  },
  day9: {
    conclusionVideo: 'Module3Videos/closing.mp4',
    rewardOption1: 'Bandanna',
    rewardOption2: 'Hat',
    learn: {
      video: 'influencers/{influencer-id}/greet_affirmation.mp4',
      song: 'appfiles/expressions/school_expressions_instrumental.m4a',
      recording: 'userfiles/{student-id}/expressions_play_day_music.m4a',
      demoSong: 'appfiles/expressions/school_expressions_singalong.m4a',
      json: 'appfiles/expressions/school_photo_montage_data_9.json',
    },
    celebrate: {
      video: 'Module3Videos/celebrate_intro_day_9.mp4',
      afterVideo: null,
      animal: true,
      text: 'Record yourself dancing and say, "I am a very important person!"',
      name: 'expressions_celebration_surprise_9.mp4',
    },
    surprise: {
      video: 'Module3Videos/surprise.mp4',
      song: 'appfiles/expressions/faces_student_instrumental.m4a',
      slides: [
        'influencers/{influencer-id}/ask_affirmation.mp4',
        'userfiles/{student-id}/expressions_celebration_surprise_6.mp4',
        'userfiles/{student-id}/expressions_smile.jpg',
        'influencers/{influencer-id}/expressions_video_message.mp4',
        'userfiles/{student-id}/expressions_celebration_surprise_8.mp4',
        'userfiles/{student-id}/expressions_silly_photo_3.jpg',
        'userfiles/{student-id}/expressions_celebration_surprise_9.mp4',
      ],
    },
  },
};

export default Module3Config;
